import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FnLoaderService, FnThemeService } from 'foundation';
import { Event,NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation:ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title = 'ai-forecast-service-client';
  isLoading = true;
  response=false;
  send(response:boolean){
    this.response=response;
  }
  constructor(
    private themeService: FnThemeService,
    private http: HttpClient,
    private router: Router,
    private loaderService: FnLoaderService){
      this.subscribeLoader();
      this.navigationRouteSubscribe();
  }
   ngOnInit(): void {
    this.useTheme('alertdashboard');
    const s = window.location+'';
    const s1 = (s.substring(0,s.indexOf('#')));   
    environment.API_BASE_URL;
  } 
  private navigationRouteSubscribe() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      }
      if (event instanceof NavigationEnd) {
        this.loaderService.hide();
      }
      if (event instanceof NavigationError) {
        this.loaderService.hide();
      }
    });
  }

  private subscribeLoader() {
    this.loaderService.ISLOADING.subscribe((resp) => {
      setTimeout(() => {
        this.isLoading = resp;
      })
    });
  }

public useTheme(themeID: string) {
    this.http.get(`assets/theme/${themeID}.json`).subscribe(res => {
        this.themeService.setTheme(res);
    });
}

 
}
